import React, { useCallback, useContext, useState } from 'react'
import CartCtx from '../CartCtx'
import CartItem from './CartItem'
import { isIterableArray } from '../block-slider/utils'
import { Alert, Button, Container } from 'react-bootstrap'
import { NavLink } from 'react-router-dom'
import SliderFetchWrapper from '../block-slider/SliderFetchWrapper'
import axios from 'axios'
import { useEffect } from 'react'
import AlertCart from './AlertCart'

const PageCart = () => {

  const { cart, removeProduct, getTotalSumm, getTotalWithoutSale } = useContext(CartCtx)

  const [isLoading, setIsLoading] = useState(true);
  const [products, setProducts] = useState([])
  const [textAlert, setTextAlert] = useState(null);

  useEffect(() => {
    if (isIterableArray(cart)) getProducts()
    else setIsLoading(false)
    getTexts()
  }, [cart])


  const getProducts = () => {
    setIsLoading(true)
    const ids = cart.map(i => i.id)
    axios.post(`${process.env.REACT_APP_API_BASE}/products/products-for-cart`, { ids })
      .then(response => {
        if (isIterableArray(response.data.data)) {
          const res = response.data.data.map(prod => ({
            ...prod,
            count_cart: cart.find(i => i.id == prod.id).count_cart
          }))
          setProducts(res)
        }
      })
      .catch(err => {
        console.log(err)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  const getTexts = () => {
    axios.get(`${process.env.REACT_APP_API_BASE}/pages/cart-text`)
      .then(response => {
        if (response.data?.text1) setTextAlert(response.data?.text1)
      })
      .catch(err => {
        console.error(err)
      })
  }


  const removeProductCart = (id) => {
    removeProduct(id)
    const filtered = products.filter(i => i.id !== id)
    setProducts(filtered)
  }


  const computedCardData = useCallback(
    () => {
      const totalWithoutSale = getTotalWithoutSale(products)
      const totalSumm = getTotalSumm(products)

      // let isDisabledCard = false

      // products.forEach(prod => {
      //   const count_cart = cart.find(i => i.id == prod.id).count_cart
      //   if (count_cart > prod.count) isDisabledCard = true
      // })
      return {
        totalWithoutSale,
        totalSumm,
        // isDisabledCard
      }
    },
    [products, cart]
  )


  const { totalWithoutSale, totalSumm } = computedCardData()

  return (
    <main className='page-cart'>
      {
        isLoading ?
          <Container>
            <div className="cart-empty">
              <h3 className='text-left'>Корзина</h3>
              <p>Загрузка...</p>
            </div>
          </Container>
          :
          <>
            {
              !isIterableArray(cart) &&
              <Container>
                <div className="cart-empty">
                  <h3>Корзина пуста</h3>
                  <NavLink to="/" className="btn btn-primary">Вернуться на главную</NavLink>
                </div>
              </Container>
            }
            {
              isIterableArray(cart) &&
              products.length > 0 &&
              <Container >
                <h3>Корзина</h3>

                {
                  textAlert?.text &&
                  <AlertCart data={textAlert} />
                }
                <div className='mb-3 lg-mb-5'>
                  <div className="page-cart-container">
                    <div className="cart-items">
                      <div className="cart-items__wrap">
                        {
                          isIterableArray(products) &&
                          products.map((product, index) => (
                            <CartItem
                              key={index}
                              product={product}
                              index={index}
                              isControl={true}
                              removeProductCart={removeProductCart}
                            />
                          ))
                        }
                      </div>
                    </div>
                  </div>
                  <div className="page-cart-footer">
                    <NavLink to="/" className='to-back'>
                      <Button variant="link" className="open-cart" >Вернуться к покупкам</Button>
                    </NavLink>
                    <div className="page-cart-footer__content">

                      <p className='total-title'>Товаров в корзине: {products.length}</p>
                      {
                        parseFloat((totalWithoutSale * 1).toFixed(2) - (totalSumm * 1).toFixed(2)) > 0 &&
                        <>
                          <div className='page-cart-footer__content--price-row'>
                            <p>Цена:</p>
                            <p>
                              <span className="i-rub">{parseFloat((totalWithoutSale * 1).toFixed(2)).toLocaleString('ru')}</span>
                            </p>
                          </div>
                          <div className='page-cart-footer__content--price-row'>
                            <p>Скидка:</p>
                            <p>
                              <span className="i-rub text-sale">-{parseFloat(totalWithoutSale.toFixed(2) - (totalSumm * 1).toFixed(2)).toLocaleString('ru')}</span>
                            </p>
                          </div>
                        </>
                      }
                      {
                        // isDisabledCard ?
                        //   <div className='page-cart-footer__content_btn disabled'>
                        //     <p className='text-center'>
                        //       Некоторые товары недоступны для заказа
                        //     </p>
                        //     <div className="btn btn-secondary disabled">Оформить заказ</div>
                        //   </div>
                        //   :
                        <div className='page-cart-footer__content_btn'>
                          <p className='text-center'>
                            {
                              parseFloat((totalWithoutSale * 1).toFixed(2) - (totalSumm * 1).toFixed(2)) > 0 ? 'Итого: ' : 'Цена: '
                            }
                            <span className="i-rub">{parseFloat((totalSumm * 1).toFixed(2)).toLocaleString('ru')}</span>
                          </p>
                          {
                            localStorage.getItem('galaxy-token') ?
                              <NavLink to="/checkout" className="btn btn-primary">Оформить заказ</NavLink>
                              :
                              <CartCtx.Consumer>
                                {({ setIsShowAuthModal }) => (
                                  <Button
                                    onClick={() => setIsShowAuthModal(true)}
                                    className='  mb-3'
                                    variant="primary"
                                  >
                                    Войти в профиль магазина и оформить заказ
                                  </Button>
                                )}
                              </CartCtx.Consumer>
                          }
                        </div>
                      }
                    </div>
                  </div>
                </div>

                {/* <SliderFetchWrapper
                  urlFetch={`${process.env.REACT_APP_API_BASE}/pages/cart-slider`}
                /> */}

              </Container>
            }
          </>
      }
    </main>
  )
}

export default PageCart